// Copyright (c) 2016 Deere & Company

import React, {
    Component,
    PropTypes
} from 'react';
import CheckboxWithSearchFilterControlled from '../../../shared/components/facets/checkbox-with-search-filter/controlled';
import FacetFooter from '../../../shared/components/facets/facet-footer/index';
import FacetsDateRangePickerControlled from '../../../shared/components/facets/date-range-picker/controlled';
import RequestTypeFacet from '../../shared/components/request-type-facet';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';
import {isDealerFacetInvalid} from '../../../shared/services/facets';
import {isRequestTypeFacetInvalid} from '../../shared/services/facets-services';

function handleDealerFilterInput(text) {

    this.props.actions.updateDealerAccountFacetInput(text);

}

function handleDealerAccountFacetItem(item, isSelected) {

    this.props.actions.updateDealerAccountFacetItem(item, isSelected);

}

function onDatePickerChange(dateRange) {

    this.props.actions.updateOpenPartRequestsDateRangeFacet(dateRange);

}

function toggleDealerAccountFacetItems() {

    this.props.actions.toggleDealerAccountFacetItems(this.props.facets.dealerAccountsFacet.allowedDealers);

}

function handleApplyFilters() {

    this.props.actions.readOpenPartRequests();

}

function handleResetFilters() {

    this.props.actions.resetAllFacets(
        this.props.facets.dealerAccountsFacet.allowedDealers,
        this.props.facets.requestTypes.allowedTypes
    );

}

const loadAllAccounts = dealerAccountsFacet =>
    dealerAccountsFacet.isInitialLoad || dealerAccountsFacet.selectedDealers.length === 0;

class OpenPartsReturnsFacets extends Component {

    state = {
        dateRangePickerExpanded: false,
        dealerLocationExpanded: false,
        requestTypeExpanded: false
    };

    componentWillMount() {

        if (loadAllAccounts(this.props.facets.dealerAccountsFacet)) {

            this.props.actions.selectAllDealersOnInitialLoad(this.props.facets.dealerAccountsFacet.allowedDealers);

        }

        this.props.actions.getRequestTypes();

    }

    onAccordionToggle = accordionName => {

        this.setState({
            [accordionName]: !this.state[accordionName]
        });

    };

    anyFacetsOpen = () =>
        this.state.dateRangePickerExpanded || this.state.requestTypeExpanded || this.state.dealerLocationExpanded;

    render() {

        return (
            <aside className='open-part-returns-facets'>
                <CheckboxWithSearchFilterControlled
                    initialState={createHashMap(this.props.facets.dealerAccountsFacet.selectedDealers, 'account')}
                    isExpanded={this.state.dealerLocationExpanded}
                    list={addCollectionLabels(this.props.facets.dealerAccountsFacet.displayedDealers)}
                    minNumberOfItems={4}
                    onCheckboxListChange={this::handleDealerAccountFacetItem}
                    onClick={this.onAccordionToggle.bind(this, 'dealerLocationExpanded')}
                    onInputChange={this::handleDealerFilterInput}
                    onToggleAll={this::toggleDealerAccountFacetItems}
                    searchInput={this.props.facets.dealerAccountsFacet.searchInput}
                    searchPlaceholder='DEALER_LOCATION_FILTER'
                    title='DEALER_LOCATIONS'
                    valueKey='account'
                />
                <RequestTypeFacet
                    actions={this.props.actions}
                    facets={this.props.facets}
                    isExpanded={this.state.requestTypeExpanded}
                    onClick={this.onAccordionToggle.bind(this, 'requestTypeExpanded')}
                    title='REQUEST_TYPE'
                />
                <FacetsDateRangePickerControlled
                    dateFormat={this.props.facets.requestDateFacet.dateFormat}
                    dateRange={this.props.facets.requestDateFacet.dateRange}
                    isExpanded={this.state.dateRangePickerExpanded}
                    maxDate={this.props.facets.requestDateFacet.maxDate}
                    minDate={this.props.facets.requestDateFacet.minDate}
                    onChange={this::onDatePickerChange}
                    onClick={this.onAccordionToggle.bind(this, 'dateRangePickerExpanded')}
                    title='REQUESTED'
                />
                {this.anyFacetsOpen() ?
                    <FacetFooter
                        disabled={isDealerFacetInvalid(this.props.facets.dealerAccountsFacet) || isRequestTypeFacetInvalid(this.props.facets.requestTypes)}
                        onApply={this::handleApplyFilters}
                        onReset={this::handleResetFilters}
                    /> : null}
            </aside>
        );

    }

}

OpenPartsReturnsFacets.displayName = 'OpenPartsReturnsFacets';
OpenPartsReturnsFacets.propTypes = {
    actions: PropTypes.object.isRequired,
    facets: PropTypes.object.isRequired
};

export default OpenPartsReturnsFacets;



// WEBPACK FOOTER //
// ./src/part-requests/open-parts-requests/components/open-part-returns-facets.js